import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=ebe10470&"
import script from "./deposit.vue?vue&type=script&lang=ts&"
export * from "./deposit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports